import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import * as ReduxForm from 'redux-form';
import { decorateWith, withName } from 'helpers/decorator';
import { ConsentMessage } from 'components/Consent/ConsentMessage';
import { ApiError } from 'components/Errors/ApiError';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import { AccountForm } from '../forms/AccountForm';
import { SignupCardCta } from '../forms/SignupCardCta';
import { ACCOUNT_FORM } from '../sagas/account.saga';
var messages = defineMessages({
  stepTitle: {
    id: 'signup-card.account.step-title',
    defaultMessage: 'What’s your name?'
  }
});
export var AccountCardUnwrapped = function AccountCardUnwrapped(_ref) {
  var error = _ref.error,
      hasSucceeded = _ref.hasSucceeded,
      hiddenFields = _ref.hiddenFields,
      isIncomplete = _ref.isIncomplete,
      isSubmitting = _ref.isSubmitting,
      onSuccess = _ref.onSuccess,
      tag = _ref.tag,
      terms = _ref.terms;
  return React.createElement("div", {
    className: "card"
  }, React.createElement(Section, {
    className: "SignupCard SignupCard--account-step"
  }, tag && React.createElement("div", {
    className: "SignupCard__tag"
  }, React.createElement("span", null, tag)), error && React.createElement("div", {
    className: "SignupCard__error"
  }, React.createElement(ApiError, {
    error: error
  })), React.createElement("header", null, React.createElement(Heading, {
    className: "SignupCard__title"
  }, React.createElement(FormattedMessage, messages.stepTitle))), React.createElement("div", {
    className: "SignupCard__form"
  }, React.createElement(AccountForm, {
    formId: ACCOUNT_FORM,
    hiddenFields: hiddenFields,
    onSuccess: onSuccess
  })), React.createElement("div", {
    className: "SignupCard__terms"
  }, React.createElement(ConsentMessage, {
    message: terms
  })), React.createElement("div", {
    className: "SignupCard__cta"
  }, React.createElement(SignupCardCta, {
    formId: ACCOUNT_FORM,
    isDisabled: !!(hasSucceeded || isIncomplete),
    isSubmitting: !!isSubmitting
  }))));
};
AccountCardUnwrapped.propTypes = {
  error: ApiError.propTypes.error,
  hasSucceeded: PropTypes.bool,
  hiddenFields: PropTypes.object,
  isIncomplete: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onSuccess: PropTypes.func.isRequired,
  tag: PropTypes.node,
  terms: PropTypes.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    error: ReduxForm.getFormError(ACCOUNT_FORM)(state),
    hasSucceeded: ReduxForm.hasSubmitSucceeded(ACCOUNT_FORM)(state),
    isIncomplete: ReduxForm.isInvalid(ACCOUNT_FORM)(state),
    isSubmitting: ReduxForm.isSubmitting(ACCOUNT_FORM)(state),
    terms: (ReduxForm.getFormValues(ACCOUNT_FORM)(state) || {}).terms
  };
};

export var AccountCard = decorateWith(connect(mapStateToProps), withName('AccountCard'))(AccountCardUnwrapped);